import { lazy } from 'react';

const CharityVettingCompanyRegistrationRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "CompanyRegistration" */ '../components/steps/company-registration-step/CompanyRegistration'
    ),
);

export default CharityVettingCompanyRegistrationRoute;
